<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleClienti > 0"
      item-key="_id"
      :headers="headers"
      :items="clientiSorted"
      :options.sync="options"
      :server-items-length="totaleClienti"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Clienti e Fornitori</v-toolbar-title>
<!--    <v-divider class="mx-4" inset vertical></v-divider> -->
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="onNuovoCliente">Nuovo Cliente</v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione cliente?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <dialog-errore :show="dialogErrore" title="Errore aggiornamento Cliente" />
      </v-toolbar>
      <filtri @ricerca="onRicerca"/>
    </template>
    <template v-slot:[`item.speciali`]="{ item }">
      <v-icon v-if="item.amministrativi.emettitoreBuoniPasto" small title="Emettitore Buoni Pasto">mdi-cash-multiple</v-icon>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
        </template>
        <span>Modifica il cliente</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="duplicateItem(item)" v-bind="attrs" v-on="on">mdi-content-duplicate</v-icon>
        </template>
        <span>Duplica il cliente</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small @click="deleteItemWithPassword(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
        </template>
        <span>Cancella il cliente</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="clientiSelected">
        <v-tabs dense v-model="tab[item._id]">
          <!-- <v-tab class="clientiSelected">Anagrafica{{item.name}}</v-tab> -->
          <v-tab class="clientiSelected">Scheda cliente{{item.name}}</v-tab>
          <v-tab>Recapiti{{item.name}}</v-tab>
          <v-tab>Contatti</v-tab>
          <v-tab>Cards</v-tab>
          <v-tab v-if="visualizzaAccessi">Accessi<v-btn icon @click="refreshAccessi++"><v-icon>mdi-refresh</v-icon></v-btn></v-tab>
          <v-tab v-if="visualizzaAllegati">Allegati</v-tab>
          <v-tab v-if="visualizzaLavorazioni">Lavorazioni</v-tab>
<!--           <v-tab>Dati amministrativi</v-tab>
          <v-tab>Ordini</v-tab>
          <v-tab>Fatture</v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tab[item._id]">
          <!-- <v-tab-item v-for="rc in item.recapiti" :key="rc"> -->
<!--           <v-tab-item>
            <anagrafica :idCliente="item._id" :dati="item" @salvaScheda="salvaScheda"/>
          </v-tab-item> -->
          <v-tab-item>
            <scheda :idCliente="item._id" :dati="item" @salvaScheda="salvaScheda" @caricaDaPiva="caricaDaPiva(item, $event)"/>
          </v-tab-item>
          <v-tab-item>
            <recapiti :idCliente="item._id" :recapiti="item.recapiti" @update-address="updateAddress" @new-address="newAddress" @delete-address="deleteAddress"/>
          </v-tab-item>
          <v-tab-item>
            <contatti :idCliente="item._id" :contatti="item.contatti" @update-contatto="updateContatto" @new-contatto="newContatto" @delete-contatto="deleteContatto"/>
          </v-tab-item>
          <v-tab-item>
            <cards :idCliente="item._id"/>
          </v-tab-item>
          <v-tab-item>
            <accessi :idCliente="item._id" :cliente="item" :refresh="refreshAccessi"/>
          </v-tab-item>          
          <v-tab-item>
            <allegati :idCliente="item._id" :allegati="item.allegati" @change="onChangeFile"/>
          </v-tab-item>
          <v-tab-item>
            <lavorazioni :idCliente="item._id" />
          </v-tab-item>
          <v-tab-item>
            <fatture :recapiti="item.recapiti" @update-address="updateAddress" @new-address="newAddress"/>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>    
    </v-data-table>
    <speed-dial />
  </div>
</template>

<script>
  import _ from 'lodash'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import { v4 as uuidv4 } from 'uuid'
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import DialogErrore from '@/components/dialogErrore'
  import SpeedDial from './speedDial.vue'
  import Filtri from './filtri'
/*   import Anagrafica from './elementi/anagrafica' */
  import Scheda from './elementi/scheda'
  import Recapiti from './elementi/recapiti'
  import Contatti from './elementi/contatti'
  import Cards from './elementi/cards'
  import Accessi from './elementi/accessi'
  import Fatture from './elementi/fatture'
  import Allegati from './elementi/allegati'
  import Lavorazioni from './elementi/lavorazioni'
  import clienti from '@/services/clientiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  
  export default {
    components: {
      DialogErrore,
      Filtri,
      SpeedDial,
/*       Anagrafica, */
      Scheda,
      Recapiti,
      Contatti,
      Cards,
      Fatture,
      Allegati,
      Lavorazioni,
      Accessi
    },
    mixins: [verificaLicenza],
    data () {
      return {
        totaleClienti: 0,
        clienti: [],
        selected: [],
        loading: true,
        options: {},
        headersBase: [
          { text: 'Codice', value: 'codice', align: 'start' },
          { text: 'Ragione sociale', value: 'ragioneSociale' },
          { text: 'Partita Iva', value: 'amministrativi.partitaIva' },
          { text: 'Indirizzo', value: 'c_indirizzo' },
          { text: 'Titolare', value: 'c_titolare' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        headersSpeciali: [
          { text: '', value: 'speciali', width: 20 }
        ],        
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: [],
        codiceCancellazione: '',
        usaBuoniPasto: false,
        visualizzaAllegati: false,
        visualizzaLavorazioni: false,
        visualizzaAccessi: false,
        refreshAccessi: 1
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Cliente' : 'Modifica Cliente'
      },
      customerSaved() {
        return this.$store.getters['clienti/saved']
      },
      refreshList() {
        return this.$store.getters['clienti/refresh']
      },
      clientiSorted() {
        const els = this.clienti
        const elSorted = els.sort(dynamicSortMultiple('ragioneSociale'))
        return elSorted
      },
      headers() {
        let base = this.usaBuoniPasto ? this.headersSpeciali : []
        return base.concat(this.headersBase)
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async customerSaved(value) {
        if (value) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('clienti/CLEAR_REFRESH')
        }
      }
    },
    async created() {
      this.defaultItem = await clienti.getModello()
      
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.codiceCancellazione = backoffice.codiceCancellazione || '0000'
      this.usaBuoniPasto = backoffice.usaBuoniPasto || false
      this.visualizzaAllegati = _.get(backoffice, 'clienti.visualizzaAllegati') || false
      this.visualizzaLavorazioni = _.get(backoffice, 'clienti.visualizzaLavorazioni') || false
      this.visualizzaAccessi = _.get(backoffice, 'clienti.visualizzaAccessi') || false
    },
    async mounted () {
      // await this.gestioneToken()      
      await this.verificaModuliLocali()
      const query = { ...this.$route.query }
      if (query && query.idedit) {
        let numero = decodeURI(query.idedit)
        setTimeout(async () => {
          this.options.page = 1
          this.filtri = {
            testo: numero
          }        
          await this.getDataFromApi()
          const item = this.clienti.find(x => x._id === numero)
          if (item) {
            this.expanded.push(item)
          }
        }, 300)
      } else {
        await this.getDataFromApi()
      }
    },
    methods: {
/*       allegatiCliente(cliente) {
        console.log(cliente.allegati)
        return cliente ? cliente.allegati : []
      }, */
      async onRicerca(filtri) {
        this.filtri = filtri
        this.options.page = 1
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          this.options.allRecords = true
          const data = await clienti.getFilteredCustomers(this.filtri, this.options, 'v3')
          this.clientiRaw = data && data.total_rows > 0 ? data.rows : []
          this.clienti = this.datiVisualizzazione(this.clientiRaw)
          this.totaleClienti = data.total_rows
        } catch(err) {
          this.clienti = []
          this.totaleClienti = 0
        } finally {
          this.loading = false
        }
      },
      async onNuovoCliente() {
        this.defaultItem = await clienti.getModello()
        if (this.defaultItem.recapiti && this.defaultItem.recapiti.length > 0) {
          this.defaultItem.recapiti[0].codice = uuidv4()
        }
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.$store.commit('clienti/SET_CLIENTE', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      editItem (item) {
        this.editedIndex = this.clienti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('clienti/SET_CLIENTE', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        this.$store.commit('clienti/SET_CLIENTE', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      deleteItemWithPassword(item) {
        if (prompt('inserire codice per cancellazione') === this.codiceCancellazione) {
          this.deleteItem(item)
        }
      },      
      deleteItem (item) {
        this.editedIndex = this.clienti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        this.clienti.splice(this.editedIndex, 1)
        // TODO: ATTENZIONE VA VERIFICATO CHE NON ABBIA STORIA
        if (!await clienti.cancellaCliente(this.editedItem)) {
          this.dialogErrore = true
        }
        this.closeDelete()
      },

      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async salvaScheda(idCliente) {
        const cliente = this.clienti.find(x => x.codice === idCliente)
        if (cliente) {
          if (!await clienti.modificaCliente(cliente)) {
            this.dialogErrore = true
          } else {

          }
          await this.getDataFromApi()
        }
      },
      async caricaDaPiva(item, { idCliente, infoAzienda }) {
        // NON FUNZIONA SALVATAGGIO
        let clienteIdx = this.clienti.findIndex(x => x.codice === idCliente)
        item = { ...item, ...infoAzienda }
        this.clienti[clienteIdx] = item
        await this.salvaScheda(idCliente)
      },
      async save () {
        this.$store.commit('clienti/CLEAR_CLIENTE_SAVED')
        this.editedItem = this.$store.getters['clienti/cliente']
        if (this.editedIndex > -1) {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          Object.assign(this.clienti[this.editedIndex], this.editedItem)
          if (!await clienti.modificaCliente(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          this.clienti.push(this.editedItem)
          if (!await clienti.creaCliente(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi()
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editedIndex = this.clienti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('clienti/SET_CLIENTE', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      datiVisualizzazione(clienti) {
        const elaborati = clienti.map(el => {
          const recapito = el.recapiti && el.recapiti.length > 0 ? el.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
          const indirizzo = recapito ? `${recapito.indirizzo}, ${recapito.localita} ${recapito.cap} - ${recapito.provincia}` : ''
          const contatto = el.contatti && el.contatti.length > 0 ? el.contatti.find(x => x.tipo && x.tipo === 'titolare') : null
          let titolare = ''
          if (contatto) {
            titolare = `${contatto.nome} ${contatto.cognome}`
            if (contatto.cellulare) {
              titolare += ` - cell: ${contatto.cellulare}`
            }
            if (contatto.email) {
              titolare += ` - email: ${contatto.email}`
            }            
          }
          el.allegati = el.allegati || []
          return { ...el, c_recapito: recapito, c_indirizzo: indirizzo, c_contatto: contatto, c_titolare: titolare }
        })
        return elaborati
      },
      deleteDatiVisualizzazione(cliente) {
        let locCliente = {...cliente}
        // Eventuale aggiornamento dati modificati
        delete locCliente.c_recapito
        delete locCliente.c_indirizzo
        delete locCliente.c_contatto
        delete locCliente.c_titolare
        return locCliente
      },
      async newAddress({ idCliente, address }) {
        await clienti.salvaDestinazione(idCliente, address)
      },
      async updateAddress({ idCliente, address }) {
        await clienti.salvaDestinazione(idCliente, address)
      },
      async deleteAddress({ idCliente, address }) {
        await clienti.eliminaDestinazione(idCliente, address)
      },      
      async newContatto({ idCliente, contatto }) {
        await clienti.salvaContatto(idCliente, contatto)
      },
      async updateContatto({ idCliente, contatto }) {
        await clienti.salvaContatto(idCliente, contatto)
      },
      async deleteContatto({ idCliente, contatto }) {
        await clienti.eliminaContatto(idCliente, contatto)
      },
      newCard({ idCliente, card }) {

      },
      updateCard({ idCliente, card }) {

      },
      async onChangeFile({ idCliente, tipo, payload }) {
        switch(tipo) {
          case 'addFile':
          case 'updateFile':
            await clienti.aggiornaAllegati(idCliente, payload)
            break
          case 'deleteFile':
            await clienti.eliminaAllegato(idCliente, payload)
            break
          default:
            break
        }
        await this.getDataFromApi()
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
  td.clientiSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
